// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Modal_modalOverlay__y_1JE","modalContent":"Modal_modalContent__KaBCi","modalClose":"Modal_modalClose__mqt7L","modalCloseIcon":"Modal_modalCloseIcon__Ht9iL"};